import * as web3 from "@solana/web3.js"
import { BILLBOARD_PROGRAM_ID } from "../utils/constants";


export class AuctionRoom {
	publicKey: web3.PublicKey | undefined
	timeDenomination: number

	constructor(
		publicKey: web3.PublicKey,
		timeDenomination: number
	) {
		this.publicKey = publicKey
		this.timeDenomination = timeDenomination
	}

	static findAddress(provider: web3.PublicKey) {
		return web3.PublicKey.findProgramAddressSync(
			[Buffer.from("auction_room"), provider.toBuffer()],
			new web3.PublicKey(BILLBOARD_PROGRAM_ID)
		)
	}
}
